export default __webpack_public_path__ + "static/media/Pross01.da4e558d.jpg";